module.exports = __webpack_public_path__ + "9f8944a627901f4b3f554e1c73bd93f0.png";